export default "__VITE_ASSET__zqdrCjwz__"